import CartItems from '../components/cartItems/cartItems'



export default function Cart() {
  return (
    <div>
      <CartItems/>
    </div>
  )
}
